var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper",style:(_vm.vid_styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }